import { useEffect, useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import validator from 'validator';
import CustomAlert from '../../components/CustomAlert';
import config from '../../config/Constant';
import { postRequestWithoutAccessToken } from '../../helpers/apiHandler';
import LeftSection from './LeftSection';

const RequestPasswordReset = () => {
  const baseUrl = process.env.PUBLIC_URL;

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState({ error: false, message: '' });
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const handleRequestPasswordResetSubmit = evt => {
    evt.preventDefault();

    const form = evt.currentTarget;

    if (form.checkValidity() === false) {
      evt.stopPropagation();
    }

    if (validator.isEmpty(email)) {
      setEmailError({
        error: true,
        message: 'Please enter your email address',
      });
      return;
    }

    if (!validator.isEmail(email)) {
      setEmailError({
        error: true,
        message: 'Email is invalid!',
      });
      return;
    }

    if (email.trim() !== '') {
      setLoading(true);
      postRequestWithoutAccessToken('/auth/request-password-reset', { email }, res => {
        if (!res.error) {
          setLoading(false);
          // Store only the email locally - don't rely on API response data for security
          localStorage.setItem('reset_password_data', JSON.stringify({ email }));
          window.location.href = `${baseUrl}/password-reset-success`;
        } else {
          setAlertState({
            show: true,
            variant: 'danger',
            message: res.message,
          });
          setLoading(false);
        }
      });
    }
  };

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div className="Authenticate RequestPasswordReset">
      <div className="container-auth-grid">
        <LeftSection />
        <div className="right-container">
          <div className="form-container-outter">
            <div className="form-container">
              <img
                alt="..."
                src={require('../../assets/elfoa2p-logo.svg')}
                height={50}
                className="d-block d-sm-none"
                style={{ marginBottom: 30 }}
              />
              <div className="form-top-section" style={{ marginBottom: 20 }}>
                <h3 style={{ marginBottom: 0 }}>Forgot Password</h3>
              </div>
              <p>Enter the email address associated with your account</p>
              <Form noValidate onSubmit={handleRequestPasswordResetSubmit}>
                <CustomAlert
                  message={alertState.message}
                  show={alertState.show}
                  variant={alertState.variant}
                  closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
                />
                <Form.Group style={{ marginBottom: 20 }}>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    required
                    type="email"
                    placeholder="Your email"
                    name="email"
                    value={email}
                    onChange={evt => {
                      setEmail(evt.target.value);
                      setEmailError({ error: false, message: '' });
                    }}
                    isInvalid={emailError.error}
                  />
                  <Form.Control.Feedback type="invalid">{emailError.message}</Form.Control.Feedback>
                </Form.Group>
                <Form.Group style={{ marginBottom: 0 }}>
                  <Button
                    variant="primary"
                    type="submit"
                    disabled={loading}
                    style={{ minWidth: '160px' }}
                  >
                    {loading && <Spinner animation="border" size="sm" className="mr-2" />}
                    Request
                  </Button>
                </Form.Group>
                <br></br>
                <span>Go back to
                  <Link to="/login"> Sign In</Link>
                </span>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestPasswordReset;
